module.exports = __webpack_public_path__ + "static/img/asani-logo-mini.6b3fb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asani-logo-mini.png
// module id = L37n
// module chunks = 0